import { getMessages as getKustomMessages } from "kustom-front/src/locales";
import enMessages from "./en.json";
import esMessages from "./es.json";
import frMessages from "./fr.json";
import itMessages from "./it.json";

export type Locale = "es" | "en" | "fr" | "it";

export const LOCALES: Locale[] = ["fr", "it", "es", "en"];
export const DEFAULT_LOCALE: Locale = "en";

interface Messages {
  [key: string]: Record<string, string>;
}
interface MessageByLocale {
  [x: string]: string;
}

const messages: Messages = {
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  it: itMessages,
};

export const getPathChangingLocale = (locale: Locale): string => {
  const localeRegex = new RegExp(/(\/en|\/es|\/fr|\/it)(\/|$)/);
  const hasLocale = localeRegex.exec(window.location.pathname);
  const isHomeWithLocale = new RegExp(/^(\/en|\/es|\/fr|\/it)$/).exec(window.location.pathname);
  const isHomeWithoutLocale = window.location.pathname === "/";

  return hasLocale
    ? isHomeWithLocale
      ? window.location.pathname.replace(/(\/en|\/es|\/fr|\/it)(\/|$)/, `/${locale}`)
      : window.location.pathname.replace(/(\/en|\/es|\/fr|\/it)(\/|$)/, `/${locale}/`)
    : isHomeWithoutLocale
    ? window.location.pathname.replace(/\//, `/${locale}`)
    : window.location.pathname.replace(/\//, `/${locale}/`);
};

export const getMessages = (locale: Locale): MessageByLocale => {
  const kustomMessages = getKustomMessages(locale);

  return { ...messages[DEFAULT_LOCALE], ...kustomMessages, ...messages[locale] };
};
